"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSvg = void 0;
const theme_1 = require("@pulse-web-ui/theme");
const tooltip_types_1 = require("../tooltip.types");
exports.StyledSvg = theme_1.styled.svg `
  ${({ error, theme, bg }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    if (error) {
        return (0, theme_1.css) `
        .hint-icon-background {
          fill: ${(_c = (_b = (_a = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _a === void 0 ? void 0 : _a.accent) === null || _b === void 0 ? void 0 : _b.error) === null || _c === void 0 ? void 0 : _c.faded};
        }
        .hint-icon-content {
          fill: ${(_e = (_d = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _d === void 0 ? void 0 : _d.icon) === null || _e === void 0 ? void 0 : _e.error};
        }
        .hint-icon-border {
          fill: ${(_g = (_f = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _f === void 0 ? void 0 : _f.icon) === null || _g === void 0 ? void 0 : _g.error};
        }
      `;
    }
    if (bg === tooltip_types_1.TooltipBgColor.GRAY) {
        return (0, theme_1.css) `
        &:hover {
          .hint-icon-background {
            fill: ${(_j = (_h = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _h === void 0 ? void 0 : _h.icon) === null || _j === void 0 ? void 0 : _j.primary};
          }
          .hint-icon-border {
            fill: ${(_l = (_k = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _k === void 0 ? void 0 : _k.icon) === null || _l === void 0 ? void 0 : _l.primary};
          }
          .hint-icon-content {
            fill: ${({ theme }) => { var _a, _b; return (_b = (_a = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _a === void 0 ? void 0 : _a.icon) === null || _b === void 0 ? void 0 : _b.inverse; }};
          }
        }

        .hint-icon-background {
          fill: none;
        }
        .hint-icon-content {
          fill: ${({ theme }) => theme.colors.neutral['70']};
        }
        .hint-icon-border {
          fill: ${({ theme }) => theme.colors.neutral['70']};
        }
      `;
    }
    if (bg === tooltip_types_1.TooltipBgColor.BLUE) {
        return (0, theme_1.css) `
        &:hover {
          .hint-icon-background {
            fill: ${({ theme }) => theme.colors.surface.brand};
          }
          .hint-icon-border {
            fill: none;
          }
          .hint-icon-content {
            fill: ${({ theme }) => { var _a; return (_a = theme === null || theme === void 0 ? void 0 : theme.colors['on-accent']) === null || _a === void 0 ? void 0 : _a.primary; }};
          }
        }

        .hint-icon-background {
          fill: ${({ theme }) => theme.colors.surface.interactive['interactive-light']};
        }
        .hint-icon-content {
          fill: ${({ theme }) => theme.colors.surface.brand};
        }
        .hint-icon-border {
          fill: none;
        }
      `;
    }
    return (0, theme_1.css) `
      &:hover {
        .hint-icon-background {
          fill: ${(_m = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _m === void 0 ? void 0 : _m.accent.action.normal};
        }
        .hint-icon-content {
          fill: ${({ theme }) => { var _a; return (_a = theme === null || theme === void 0 ? void 0 : theme.colors['on-accent']) === null || _a === void 0 ? void 0 : _a.primary; }};
        }
      }
      .hint-icon-background {
        fill: ${(_o = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _o === void 0 ? void 0 : _o.neutral['20']};
      }
      .hint-icon-content {
        fill: ${(_q = (_p = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _p === void 0 ? void 0 : _p.icon) === null || _q === void 0 ? void 0 : _q.primary};
      }
    `;
}}
`;
